import { create } from "zustand";
import { TAdmin } from "./admin.type";
import adminApi from "@/api/admin";
import adminAuthService from "@/features/Admins/Auth/services/index";
import { api } from "@/api";

export const adminState = create<TAdmin | null>(() => null);

const adminService = {
  getAdmin: async (cache = false) => {
    if (!adminAuthService.isLoggedIn()) return null;
    if (adminState.getState() !== null && !cache) return adminState.getState();
    const { data } = await adminApi.me();
    if (data.data.success) {
      adminAuthService.setLoggedIn();
    }
    adminState.setState(data.data.admin);
    return data.data.admin;
  },

  updateMemberPaymentSlip: async (data: {}) => {
    return await api.post("admins/update-payment-slip", data);
  },
};

export default adminService;
